import { render } from "./BasicMultiselect.vue?vue&type=template&id=56f5ec84"
import script from "./BasicMultiselect.vue?vue&type=script&lang=js"
export * from "./BasicMultiselect.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__